import { createStore } from 'satcheljs';
export default createStore('storageOption', {
    usagePercentage: 0,
    amountUsed: 0,
    usageInBytes: 0,
    sendQuota: { IsUnlimited: true, Value: 0 },
    sendReceiveQuota: { IsUnlimited: false, Value: 0 },
})();
//# sourceMappingURL=store.js.map